/* eslint-disable arrow-body-style,import/prefer-default-export  */

export const visitorIdSelector = state => state.visitorId && state.visitorId.data;
